module.exports = __webpack_public_path__ + "static/img/kwh_good3.d2d170c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productConter/goods/kwh_good3.png
// module id = LXnK
// module chunks = 1